import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GlobalIpAccessComponent } from './global-ip-access.component';
import { GlobalIpAccessListComponent } from './global-ip-access-list/global-ip-access-list.component';
import { GlobalIpAddEditComponent } from './global-ip-add-edit/global-ip-add-edit.component';

const routes: Routes = [
  {
    path:'',
    component: GlobalIpAccessComponent,
    children: [
      {
        path: 'ip-address-list',
        component: GlobalIpAccessListComponent
      },
      {
        path: 'whitelist-iP',
        component: GlobalIpAddEditComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GlobalIpAccessRoutingModule { }
